import { CountryCode } from '@api/types/country_code';
import { keyBy } from 'lodash';
import * as countryCodes from './countryCodes.json';

const COUNTRY_CODES = keyBy((countryCodes as any).default, 'twoLetterCode');

export const SMS_SUPPORTED_COUNTRY_CODES: CountryCode[] = ['us', 'ca', 'mx', 'dk', 'gb', 'fr'].map(
  (countryCode) => COUNTRY_CODES[countryCode]
);
